import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import SafeServices from "@/pages/SafeServices";
import OurWork from "@/pages/OurWork";
import Reviews from "@/pages/Reviews";
import About from "@/pages/About";
import ServiceAreas from "@/pages/ServiceAreas";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <SmoothScroll>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/safe-services" element={<SafeServices />} />
              <Route path="/our-work" element={<OurWork />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/about" element={<About />} />
              <Route path="/service-areas" element={<ServiceAreas />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </SmoothScroll>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
